// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.side-bar[data-v-b2338796] {\n    width: 165px;\n}\n", ""]);
// Exports
module.exports = exports;
